// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"166":"public-app","378":"admin-app"}[chunkId] || chunkId) + "." + {"164":"b037241b","166":"8d9d3d76","240":"4790964c","318":"ccb75354","378":"1dbd5b55","577":"541f1429","583":"12eae89f","627":"3981f2bf","678":"ccd91ed3","702":"57566a5a"}[chunkId] + ".chunk.js";
};